import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Alert, Button, Typography } from "@mui/material";
import { ReactNode } from "react";

interface AlertBannerProps {
  message: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  message,
  actionLabel,
  onAction,
  actionDisabled = false,
}: AlertBannerProps) => {
  return (
    <Alert
      severity="warning"
      icon={<WarningAmberIcon />}
      sx={{
        width: "100%",
        "& .MuiAlert-icon": { color: "warning.main" },
      }}
      action={
        actionLabel && onAction ? (
          <Button
            size="small"
            variant="outlined"
            onClick={onAction}
            disabled={actionDisabled}
          >
            {actionLabel}
          </Button>
        ) : undefined
      }
    >
      <Typography variant="body2">{message}</Typography>
    </Alert>
  );
};
